@if (message$) {
  <div  class="scroll" (click)="showNotices()">
    @for (m of message$ | async; track m) {
      <span> {{ m }}<br> </span>
    }
  </div>
}

